import {SENTRY_DSN, SENTRY_TUNNEL} from "@config";
import * as Sentry from "@sentry/vue";

export function initSentry(app?: any) {
  if (SENTRY_DSN) {

    document.addEventListener('DOMContentLoaded', () => {
      const userId = document.querySelector("meta[name=uid]")?.getAttribute("content");
      if (userId) {
        Sentry.setUser({ id: userId })
      }
    })

    if (app) {
      initSentryVue(app)
    } else {
      initSentryBrowser()
    }
  }
}

function initSentryBrowser() {
  const release = document.querySelector("meta[name=release]")?.getAttribute("content") || undefined;

  Sentry.init({
    dsn: SENTRY_DSN,
    // without a Vue app, skip the Vue integration added by default
    defaultIntegrations: Sentry.getDefaultIntegrations({}),
    // debug: true,
    integrations: [
      // Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    release: release,
    tracesSampleRate: 1.0,
    tunnel: SENTRY_TUNNEL,
  })
}

function initSentryVue(app: any) {
  Sentry.init({
    app: app,
    dsn: SENTRY_DSN,
    integrations: [
      // Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: 1.0,
    tunnel: SENTRY_TUNNEL,
  })
}
